import { CheckIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnPortal = ({ portal, onChangeReturnPortal, isSelected }) => {
  const theme = useTheme()

  return (
    <Styles.ReturnPortalContainer onClick={() => onChangeReturnPortal(portal.id)}>
      <Styles.CheckIconContainer>{isSelected && <CheckIcon size={24} weight="bold" />}</Styles.CheckIconContainer>
      <Styles.ReturnPortalLogo src={portal?.theme?.returns_favicon_url || portal?.theme?.logo_url} alt={portal.name} />
      <div>
        <Text type="bodyMRegular" customStyles={{ fontWeight: isSelected ? '600' : '400' }}>
          {portal.internal_name}
        </Text>
        <Text type="bodySRegular" customStyles={{ color: theme.colors.text.subtle }}>
          {portal.store?.domain}
        </Text>
      </div>
    </Styles.ReturnPortalContainer>
  )
}

export default ReturnPortal
